var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "rbvp-section-content" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-section-header" }, [
        _c("div", { staticClass: "rbvp-section-title" }, [
          _vm._v("主规则视图"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rbvp-section-actions" }, [
          _c("div", { staticClass: "rbvp-inline-tabs" }, [
            _c(
              "button",
              {
                staticClass: "rbvp-inline-tab",
                class: { active: _vm.state.ruleEditorMode === "visual" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.actions.setRuleEditorMode("visual")
                  },
                },
              },
              [_vm._v("\n          可视化视图\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "rbvp-inline-tab",
                class: { active: _vm.state.ruleEditorMode === "text" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.actions.setRuleEditorMode("text")
                  },
                },
              },
              [_vm._v("\n          文本视图\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "rbvp-inline-tab",
                class: { active: _vm.state.ruleEditorMode === "context" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.actions.setRuleEditorMode("context")
                  },
                },
              },
              [_vm._v("\n          上下文视图\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "rbvp-inline-tab",
                class: { active: _vm.state.ruleEditorMode === "debug" },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.actions.setRuleEditorMode("debug")
                  },
                },
              },
              [_vm._v("\n          调试视图\n        ")]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.state.ruleEditorMode === "visual"
        ? _c("div", { staticClass: "rbvp-rules-editor" }, [
            _c("div", { staticClass: "rbvp-rules-toolbar" }, [
              _c("div", { staticClass: "rbvp-rules-toolbar-meta" }, [
                _c("span", [
                  _vm._v(
                    "共 " + _vm._s(_vm.state.visualRules.length) + " 条规则"
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("可通过移动按钮调整优先级，越靠上越先匹配"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "rbvp-rules-toolbar-actions" }, [
                _c(
                  "div",
                  { staticClass: "rbvp-rules-toolbar-primary" },
                  [
                    _c(
                      "VButton",
                      {
                        attrs: {
                          type: _vm.state.hasUnsavedRulesChanges
                            ? "primary"
                            : undefined,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.actions.saveRules()
                          },
                        },
                      },
                      [_vm._v("\n            保存主规则\n          ")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rbvp-rule-create-actions" },
                  [
                    _c(
                      "VButton",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.expandAllRules()
                          },
                        },
                      },
                      [_vm._v("全部展开")]
                    ),
                    _vm._v(" "),
                    _c(
                      "VButton",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.collapseAllRules()
                          },
                        },
                      },
                      [_vm._v("全部收起")]
                    ),
                    _vm._v(" "),
                    _c(
                      "VButton",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.actions.insertBasicRule(0)
                          },
                        },
                      },
                      [_vm._v("新增基础匹配")]
                    ),
                    _vm._v(" "),
                    _c(
                      "VButton",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.actions.insertLogicRule(0)
                          },
                        },
                      },
                      [_vm._v("新增逻辑组合")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.state.visualRules.length === 0
              ? _c(
                  "div",
                  { staticClass: "rbvp-empty-state rbvp-rules-empty" },
                  [
                    _c("div", { staticClass: "rbvp-empty-state-title" }, [
                      _vm._v("还没有主规则"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "rbvp-empty-state-text" }, [
                      _vm._v(
                        "\n        可以先新增一条规则，或切到文本视图批量粘贴已有规则。\n      "
                      ),
                    ]),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "rbvp-rule-cards" },
                  _vm._l(_vm.state.visualRules, function (rule, index) {
                    return _c(
                      "div",
                      { key: rule.id, staticClass: "rbvp-rule-card" },
                      [
                        _c("div", { staticClass: "rbvp-rule-card-header" }, [
                          _c(
                            "div",
                            { staticClass: "rbvp-rule-card-title-area" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "rbvp-rule-card-type",
                                  class: {
                                    logic: rule.matcher.matcherKind === "logic",
                                    basic: rule.matcher.matcherKind === "basic",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        rule.matcher.matcherKind === "logic"
                                          ? "逻辑组合"
                                          : "基础匹配"
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              rule.editingTitle
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "rbvp-rule-card-title-edit",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.trim",
                                            value: rule.title,
                                            expression: "rule.title",
                                            modifiers: { trim: true },
                                          },
                                        ],
                                        ref: "titleInputs",
                                        refInFor: true,
                                        staticClass:
                                          "rbvp-input rbvp-rule-title-input",
                                        attrs: {
                                          placeholder: `第 ${
                                            _vm.toRuleIndex(index) + 1
                                          } 条`,
                                        },
                                        domProps: { value: rule.title },
                                        on: {
                                          blur: [
                                            function ($event) {
                                              return _vm.finishRuleTitleEdit(
                                                rule
                                              )
                                            },
                                            function ($event) {
                                              return _vm.$forceUpdate()
                                            },
                                          ],
                                          keydown: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              $event.preventDefault()
                                              return _vm.finishRuleTitleEdit(
                                                rule
                                              )
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "esc",
                                                  27,
                                                  $event.key,
                                                  ["Esc", "Escape"]
                                                )
                                              )
                                                return null
                                              $event.preventDefault()
                                              return _vm.cancelRuleTitleEdit(
                                                rule
                                              )
                                            },
                                          ],
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              rule,
                                              "title",
                                              $event.target.value.trim()
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "rbvp-rule-card-index" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.getRuleDisplayTitle(
                                              rule,
                                              _vm.toRuleIndex(index)
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              !rule.editingTitle
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "rbvp-icon-button rbvp-rule-title-button",
                                      attrs: {
                                        type: "button",
                                        title: "编辑标题",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.startRuleTitleEdit(rule)
                                        },
                                      },
                                    },
                                    [
                                      _c("VIcon", {
                                        attrs: { icon: "mdi-pencil", size: 16 },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "rbvp-rule-card-actions" }, [
                            _c(
                              "button",
                              {
                                staticClass: "rbvp-icon-button",
                                attrs: {
                                  type: "button",
                                  title: rule.collapsed
                                    ? "展开规则"
                                    : "收起规则",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleRuleCollapsed(rule)
                                  },
                                },
                              },
                              [
                                _c("VIcon", {
                                  attrs: {
                                    icon: rule.collapsed
                                      ? "mdi-chevron-down"
                                      : "mdi-chevron-up",
                                    size: 16,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "rbvp-icon-button",
                                attrs: { type: "button", title: "上移" },
                                on: {
                                  click: function ($event) {
                                    _vm.moveRule(_vm.toRuleIndex(index), -1)
                                  },
                                },
                              },
                              [
                                _c("VIcon", {
                                  attrs: { icon: "mdi-arrow-up", size: 16 },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "rbvp-icon-button",
                                attrs: { type: "button", title: "下移" },
                                on: {
                                  click: function ($event) {
                                    _vm.moveRule(_vm.toRuleIndex(index), 1)
                                  },
                                },
                              },
                              [
                                _c("VIcon", {
                                  attrs: { icon: "mdi-arrow-down", size: 16 },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "rbvp-icon-button",
                                attrs: { type: "button", title: "在下方新增" },
                                on: {
                                  click: function ($event) {
                                    _vm.togglePendingInsertIndex(
                                      _vm.toRuleIndex(index) + 1
                                    )
                                  },
                                },
                              },
                              [
                                _c("VIcon", {
                                  attrs: { icon: "mdi-plus", size: 16 },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "rbvp-icon-button danger",
                                attrs: { type: "button", title: "删除规则" },
                                on: {
                                  click: function ($event) {
                                    _vm.removeVisualRule(_vm.toRuleIndex(index))
                                  },
                                },
                              },
                              [
                                _c("VIcon", {
                                  attrs: {
                                    icon: "mdi-delete-outline",
                                    size: 16,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        rule.collapsed
                          ? _c(
                              "div",
                              { staticClass: "rbvp-rule-card-collapsed" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "rbvp-rule-card-preview" },
                                  [_vm._v(_vm._s(_vm.formatVisualRule(rule)))]
                                ),
                              ]
                            )
                          : rule.matcher.matcherKind === "basic"
                          ? _c(
                              "div",
                              { staticClass: "rbvp-rule-basic-editor" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "rbvp-rule-card-body" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "rbvp-field" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "rbvp-field-label" },
                                          [_vm._v("规则类型")]
                                        ),
                                        _vm._v(" "),
                                        _c("VDropdown", {
                                          attrs: {
                                            items: _vm.state.visualMatcherTypes,
                                            "key-mapper": (item) => item,
                                          },
                                          on: {
                                            change: (newType) =>
                                              _vm.handleBasicMatcherTypeChange(
                                                rule.matcher,
                                                newType
                                              ),
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "item",
                                                fn: function ({ item }) {
                                                  return [_vm._v(_vm._s(item))]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: rule.matcher.matcherType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                rule.matcher,
                                                "matcherType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "rule.matcher.matcherType",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.needsMatcherArgument(rule.matcher)
                                      ? _c(
                                          "label",
                                          { staticClass: "rbvp-field" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "rbvp-field-label",
                                              },
                                              [_vm._v("匹配参数")]
                                            ),
                                            _vm._v(" "),
                                            rule.matcher.matcherType ===
                                            "RULE-SET"
                                              ? _c("VDropdown", {
                                                  attrs: {
                                                    items:
                                                      _vm.state.ruleSetNames,
                                                    "key-mapper": (item) =>
                                                      item,
                                                    disabled:
                                                      _vm.state.ruleSetNames
                                                        .length === 0,
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "item",
                                                        fn: function ({
                                                          item,
                                                        }) {
                                                          return [
                                                            _vm._v(
                                                              _vm._s(item)
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                  model: {
                                                    value:
                                                      rule.matcher
                                                        .matcherArgument,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        rule.matcher,
                                                        "matcherArgument",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "rule.matcher.matcherArgument",
                                                  },
                                                })
                                              : _c("TextBox", {
                                                  attrs: {
                                                    validator: (v) => v.trim(),
                                                    placeholder:
                                                      _vm.getMatcherArgumentPlaceholder(
                                                        rule.matcher.matcherType
                                                      ),
                                                  },
                                                  model: {
                                                    value:
                                                      rule.matcher
                                                        .matcherArgument,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        rule.matcher,
                                                        "matcherArgument",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "rule.matcher.matcherArgument",
                                                  },
                                                }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { staticClass: "rbvp-field" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "rbvp-field-label" },
                                          [_vm._v("执行动作")]
                                        ),
                                        _vm._v(" "),
                                        _c("TextBox", {
                                          attrs: {
                                            validator: (v) => v.trim(),
                                            placeholder: "rememberVideoSpeed:1",
                                          },
                                          model: {
                                            value: rule.actions,
                                            callback: function ($$v) {
                                              _vm.$set(rule, "actions", $$v)
                                            },
                                            expression: "rule.actions",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c("RBVPLogicConditionEditor", {
                              attrs: {
                                "default-matcher-arguments":
                                  _vm.state.defaultMatcherArguments,
                                "rule-set-names": _vm.state.ruleSetNames,
                                "visual-matcher-types":
                                  _vm.state.visualMatcherTypes,
                                "logic-matcher-types":
                                  _vm.state.logicMatcherTypes,
                              },
                              model: {
                                value: rule.matcher,
                                callback: function ($$v) {
                                  _vm.$set(rule, "matcher", $$v)
                                },
                                expression: "rule.matcher",
                              },
                            }),
                        _vm._v(" "),
                        !rule.collapsed &&
                        _vm.state.pendingInsertIndex ===
                          _vm.toRuleIndex(index) + 1
                          ? _c("div", { staticClass: "rbvp-rule-insert" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "rbvp-rule-choice",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.actions.insertBasicRule(
                                        _vm.toRuleIndex(index) + 1
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            新增基础匹配\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "rbvp-rule-choice",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.actions.insertLogicRule(
                                        _vm.toRuleIndex(index) + 1
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            新增逻辑组合\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "rbvp-rule-choice-cancel",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.actions.setPendingInsertIndex(
                                        null
                                      )
                                    },
                                  },
                                },
                                [_vm._v("\n            取消\n          ")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !rule.collapsed && rule.matcher.matcherKind === "logic"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "rbvp-rule-card-body rbvp-rule-card-body-actions",
                              },
                              [
                                _c(
                                  "label",
                                  { staticClass: "rbvp-field" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "rbvp-field-label" },
                                      [_vm._v("执行动作")]
                                    ),
                                    _vm._v(" "),
                                    _c("TextBox", {
                                      attrs: {
                                        validator: (v) => v.trim(),
                                        placeholder: "rememberVideoSpeed:1",
                                      },
                                      model: {
                                        value: rule.actions,
                                        callback: function ($$v) {
                                          _vm.$set(rule, "actions", $$v)
                                        },
                                        expression: "rule.actions",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !rule.collapsed
                          ? _c(
                              "div",
                              {
                                staticClass: "rbvp-rule-card-preview",
                                class: {
                                  incomplete: _vm.isRuleIncomplete(rule),
                                  "has-error": rule.validationError,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "rbvp-rule-card-preview-text",
                                  },
                                  [_vm._v(_vm._s(_vm.formatVisualRule(rule)))]
                                ),
                                _vm._v(" "),
                                rule.validationError
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "rbvp-rule-card-preview-error",
                                      },
                                      [
                                        _c("VIcon", {
                                          staticClass:
                                            "rbvp-rule-card-preview-alert",
                                          attrs: {
                                            icon: "mdi-alert-circle-outline",
                                            size: 14,
                                          },
                                        }),
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(rule.validationError) +
                                            "\n          "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !rule.collapsed
                          ? _c("div", { staticClass: "rbvp-rule-card-hint" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.getMatcherHint(rule.matcher)) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
          ])
        : _vm.state.ruleEditorMode === "text"
        ? _c("RBVPTextTab", {
            attrs: { state: _vm.state, actions: _vm.actions },
          })
        : _vm.state.ruleEditorMode === "context"
        ? _c("RBVPContextTab", { attrs: { state: _vm.state } })
        : _c("RBVPDebugTab", { attrs: { state: _vm.state } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "rbvp-guide-card" }, [
      _c("div", { staticClass: "rbvp-guide-title" }, [_vm._v("主规则")]),
      _vm._v(" "),
      _c("div", { staticClass: "rbvp-guide-text" }, [
        _vm._v(
          "\n      可视化视图适合逐条整理规则顺序和内容，文本视图适合一次性快速编辑，上下文视图可查看当前匹配上下文，调试视图可查看最近一次匹配时的规则尝试路径。支持使用\n      "
        ),
        _c("code", [_vm._v("RULE-SET")]),
        _vm._v(" 引用本地规则集，也支持通过 "),
        _c("code", [_vm._v("FINAL")]),
        _vm._v("\n      指定兜底行为。\n    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }